import { isBoolean, isNumber, size, trim, get, includes } from 'lodash-es';
import { checkIsNull } from '../../Utils/utils';

/**
 * get Correct Value "for required Yup validation."
 */
export const getValueCustom = value => {
  try {
    if (isBoolean(value) || isNumber(value)) return value;

    const findNewLineItem = includes(value, '\n'); // Hack for `complément d'adresse`
    let newValue = value;

    if (!findNewLineItem) {
      newValue = size(trim(value)) > 0 ? trim(value) : undefined;
    }

    return newValue;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getValueCustom: ${e.stack}`);
  }
  return undefined;
};

/**
 * get Last Sequence Of Questions
 * @param {*} param0
 */
export const getLastSequenceOfQuestions = ({ data }) => {
  try {
    const groups = get(data[size(data) - 1], 'groups');
    const indexLastGroup = size(groups) - 1;
    //
    const areas = get(groups[indexLastGroup], 'areas');
    const indexLastArea = size(areas) - 1;
    //
    const questions = get(areas[indexLastArea], 'questions');
    const lastSequence = get(questions[size(questions) - 1], 'sequence');
    //
    return lastSequence;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getLastSequenceOfQuestions: ${e.stack}`);
  }
  return undefined;
};

/**
 * slice value
 * @param {*} value
 * @param {*} start
 * @param {*} end
 */
export const sliceValue = (value, start, end) => {
  try {
    if (!checkIsNull(value)) {
      return value.slice(start, end);
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`sliceValue ${e.stack}`);
  }
  return value;
};

/**
 * parse value decimal digits
 * @param {*} value
 * @param {*} digits
 */
export const checkFormatValueSlice = (value, slice) => {
  try {
    if (!checkIsNull(value)) {
      const length = size(value);
      if (length > slice) {
        return sliceValue(value, 0, slice);
      }
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
  return value;
};
